<template>
  <basic-container>
    <Search />
    <Table />
  </basic-container>
</template>

<script>
import { observable } from 'vue';
import Search from './components/search.vue'
import Table from './components/table.vue'
import { getTacticsList } from '@/api/pluginManage/pluginTactics'
export default {
  name: 'WebSaaSIndex',
  provide() {
    return {
      searchParams: this.searchParams,
      list: this.list,
      loadList: this.loadList
    }
  },
  components: {
    Search,
    Table
  },
  created() {
    this.loadList()
  },
  data() {
    return {
      // 搜索参数
      searchParams: observable({
        // 应用类型
        appType: "",
        // 多条件搜索
        search: "",
        current: 1,
        size: 10,
        total: 50,
      }),
      // 列表
      list: observable({
        value: [
        ]
      })
    };
  },

  methods: {
    // 分页方法
    async loadList() {
      const params = { ...this.searchParams };
      const { data } = await getTacticsList(params);
      console.log('分页查询插件管理接口的响应', data);
      this.list.value = data.data.records;
      this.searchParams.total = data.data.total;
    }
  },
};
</script>

<style lang="scss" scoped></style>